import { G } from '@mobily/ts-belt';
import WarningIcon from '@mui/icons-material/Warning';
import { Stack, Typography } from '@mui/material';
import { TextField, useRecordContext, useTranslate } from 'react-admin';

import { GetB2bCampaignsPayoutsOneResponse } from '@Common/types/b2b/campaigns';

import { IdField } from '@sh4res/bo-common/fields';
import { isBoExternal } from '@sh4res/bo-common/utils/env';

/**
 * for now transfers are an internal BO resource with no external equivalent
 *
 * omit this when transfers have their own bo_external route
 */
const INTERNAL_TRANSFERS_RESOURCE = 'transfers';

export const PayoutByCompanyWarning = ({ 'data-testid': testId }: { 'data-testid'?: string }) => {
  const translate = useTranslate();

  return (
    <Stack direction="row" alignItems="center" gap={0.5} data-testid={testId}>
      <WarningIcon color="error" fontSize="small" />
      <Typography variant="body2" color="error">
        {translate(
          isBoExternal()
            ? 'resources.bo_common.b2b.payouts.payout_by_company_warning_external'
            : 'resources.bo_common.b2b.payouts.payout_by_company_warning',
        )}
      </Typography>
    </Stack>
  );
};

export const PayoutTransferIdField = ({
  'data-testid': testId,
}: {
  source?: string;
  label?: string;
  'data-testid'?: string;
}) => {
  const record = useRecordContext<GetB2bCampaignsPayoutsOneResponse>();

  if (!record) {
    return null;
  }

  if (record.payout_by === 'company' && G.isNullable(record.transfer_id)) {
    return <PayoutByCompanyWarning data-testid={`${testId}_PayoutByCompanyWarning`} />;
  }

  return isBoExternal() ? (
    <TextField source="transfer_id" data-testid={testId} />
  ) : (
    <IdField source="transfer_id" reference={INTERNAL_TRANSFERS_RESOURCE} data-testid={testId} />
  );
};
